import ApiConfig from '@/server-config/domain.config'
export default function({
  route,
  redirect,
  app
}) {
  // 判断是不是查询 SellerAPP 轨迹， 是的话做重定向
  const pathName = route.path
  const id = route.params.id
  const site = ApiConfig.EBES_B2C_SELLER_API.indexOf('kilitest.com') > -1 ? 'test' : 'ke'
  if (pathName.indexOf('/sellerApp/logistics') > -1 && id) {
    return redirect(`/sellerApp/#/logistics/${id}?code=${site}`)
  }
}
